<template functional>
  <GmapCluster
    :gridSize="30"
    :zoomOnClick="true"
    :minimumClusterSize="3"
    ref="cluster"
    :styles="[{
      textSize: 18,
      url: props.imagePath,
      height: 40,
      width: 40,
      fontStyle: 'Roboto,Arial,sans-serif'
    }]"
  >
    <slot></slot>
  </GmapCluster>
</template>

<script>
import {
  Component, Vue
} from 'vue-property-decorator';

@Component
export default class TheMapCluster extends Vue {
  mounted() {
    this.$nextTick(() => {
      const clusterer = this.$reft.cluster.$clusterObject;

      if (clusterer) {
        clusterer.addListener('clustringstart', () => {
          this.$emit('clusteringstart');
        });
      }
    });
  }
}
</script>

<style lang="scss">
.cluster {
  img {
    height: 40px;
    width: 40px;
  }
}
</style>
